import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Card, Container} from 'react-bootstrap'
import FiltrosInformeHonorarios from './filtros-informe-honorarios'
import InformesHonorariosPrevios from './informes-honorarios-previos'
import {Auth, LoadingComponent} from 'recupero-comunes'
import { obtenerInformesPrevios, configuracionFormAction, obtenerOrigenHonorario, obtenerSituacionHonorario, obtenerResponsablesSolicitud, obtenerCriteriosFecha } from '../../store/actions/informe-honorarios-action'

const InformeHonorarios = () => {
    const dispatch = useDispatch()
    const [loading, setLoading]=useState(false)
    const data_informes = useSelector((state) => state.informeHonorariosReducer)
    const { cfg_formInf } = data_informes
    const {rutUsuario, rutOrganizacion} = Auth.currentUser()
    
    useEffect(() => {
        setLoading(true)
        let query = Buffer.from(JSON.stringify({rutcia: rutOrganizacion, idform: 98})).toString('base64')
        dispatch(configuracionFormAction(query))
        .then(()=>{
            let query = Buffer.from(JSON.stringify({concepto: 207})).toString('base64')
            dispatch(obtenerOrigenHonorario(query))
         })
         .then(()=>{
            let query = Buffer.from(JSON.stringify({'rutcia': rutOrganizacion && rutOrganizacion})).toString('base64')  
            dispatch(obtenerResponsablesSolicitud(query));
        })    
        .then(()=>{
            let query = Buffer.from(JSON.stringify({concepto: 305})).toString('base64')
            dispatch(obtenerSituacionHonorario(query))
         })
        .then(()=>{
            let query = Buffer.from(JSON.stringify({concepto: 308})).toString('base64')
            dispatch(obtenerCriteriosFecha(query))
        })
         .then(()=>{
            let query = Buffer.from(JSON.stringify({'rutcia': rutOrganizacion && rutOrganizacion, 'rutusr': rutUsuario && rutUsuario})).toString('base64')  
            dispatch(obtenerInformesPrevios(query));
         })
        .then(()=>setLoading(false))
     }, [dispatch])
    return (
        <div>            
            <LoadingComponent show={loading}/>
            <Container>
                <Card className='mt-2'>
                    <Card.Header as='h6' className="text-center" style={{backgroundColor:"#4F517A", color:"white"}} >
                        {cfg_formInf && cfg_formInf.cfg_formInf && cfg_formInf.cfg_formInf['informe-hono-title'] ? cfg_formInf.cfg_formInf['informe-hono-title'] : "Informe de Honorarios"}
                    </Card.Header>
                    <Card.Body>
                        <FiltrosInformeHonorarios/>
                        <InformesHonorariosPrevios/>
                    </Card.Body>
                </Card>
            </Container>            
        </div>
  )
}
export default InformeHonorarios 